<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20 pt-15">
        <div class="bold9 size20 color1">
          竞价公告详情页
          <!-- <span style="font-size: 14px; color: #ccd9e9">
            Bulletin Details</span
          > -->
        </div>
      </div>
      <!-- 内容 -->
      <div class="flex between">
        <!-- 列表 -->
        <div>
          <div class="listBox">
            <div style="font-size: 24px; color: #3b426b; margin-bottom: 7px">
              {{ jingJiaDetail.annTitle }}
            </div>
            <span style="font-size: 14px; color: #ccd9e9; margin-right: 20px">{{
              jingJiaDetail.publishTime
            }}</span>
            <span style="font-size: 14px; color: #ccd9e9"
              >浏览量：{{ jingJiaDetail.views }}</span
            >
            <el-divider class="divider"></el-divider>
            <div
              class="detail-content ql-editor"
              v-html="jingJiaDetail.annContent"
              style="color: #3b426b; line-height: 2em"
            ></div>
            <!-- 安妮 -->
            <div class="btn" @click="goDetail">竞价详情</div>
          </div>
        </div>
        <!-- 图片 -->
        <img
          style="width: 324px; height: 397px"
          src="../assets/imgs/gonggao.png"
          alt=""
        />
      </div>
    </div>

    <Footer class="mt-15" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: { Footer },

  data() {
    return {
      jid: null,
      jingJiaDetail: {},
    };
  },
  created() {
    this.jid = this.$route.query.id;
    console.log(this.jid);
  },
  mounted() {
    this.getJingJiaDetail();
    this.viewsAdd();
  },
  methods: {
    //跳转竞价详情
    goDetail() {
      window.sessionStorage.setItem("jjId", this.jingJiaDetail.biddingId);
      this.$router.push("/jjlbxq");
    },
    //获取竞价公告详情
    async getJingJiaDetail() {
      const { data: res } = await this.$axios.get(
        "/api/annInfo/getBiddingAnnDeail",
        {
          params: {
            biddingAnnId: this.jid,
          },
        }
      );
      if (res.code == 200) {
        this.jingJiaDetail = res.data;
      } else {
        console.log(res.msg);

        return;
      }
    },
    //提交浏览量
    async viewsAdd() {
      const { data: res } = await this.$axios({
        url: "/api/annInfo/updateView",
        method: "put",
        params: {
          annId: this.jid,
          annType: 2,
        },
      });
      console.log(res);
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png");
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}
/deep/.divider.el-divider--horizontal {
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #95b3db;
}
.listBox {
  width: 855px;
  min-height: 400px;
  background-color: #fff;
  padding: 32px 40px;
  box-sizing: border-box;
  position: relative;
  .btn {
    margin: auto;
    width: 120px;
    height: 40px;
    border-radius: 25px;
    margin-top: 36px;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    background-color: #1c65c4;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 50%;
    margin-left: -60px;
  }
}
.detail-content {
  img {
    width: 100% !important;
  }
}
</style>